import { render, staticRenderFns } from "./HomeFavorites.vue?vue&type=template&id=7f0e358a&scoped=true"
import script from "./HomeFavorites.vue?vue&type=script&lang=js"
export * from "./HomeFavorites.vue?vue&type=script&lang=js"
import style0 from "./HomeFavorites.vue?vue&type=style&index=0&id=7f0e358a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0e358a",
  null
  
)

export default component.exports